
<f-dialog
    icon          = "mdi-information"
    :title        = "title"
    v-model       = "show"
    :width        = "600"
    :hide-actions = "true"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <div v-if="info" class="mt-2 mb-3">
            <v-row dense>
                <v-col class="no-frame">
                    <f-read-only-field
                        label="Name"
                        :value="info.name"
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col class="no-frame pr-2">
                    <f-read-only-field
                        label="Besitzer"
                        :value="info.owner"
                    />
                </v-col>
                <v-col class="no-frame pr-2">
                    <f-read-only-field
                        label="Erstellt"
                        :value="format (info.created)"
                    />
                </v-col>
                <v-col class="no-frame pl-2">
                    <f-read-only-field
                        label="Letzte Änderung"
                        :value="format (info.modified)"
                    />
                </v-col>
            </v-row>
            <v-row dense class="mt-4">
                <v-col class="no-frame">
                    <f-read-only-field
                        label="Archiv"
                        :value="info.archive"
                    />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col class="no-frame">
                    <div class="readonly-label primary--text" style="font-size: 11px;">
                        Referenzen
                    </div>
                    <div class="doc-pathname" v-for="(parent, index) in info.parents" :key="index">
                        {{ parent }}
                    </div>
                </v-col>
            </v-row>
        </div>
    </template>
</f-dialog>
